import React from "react";

import { useNetworkMetadata } from "Flocknote/apiHooks";

import CheckboxSettingSection from "Signups/FamilyRegistration/Shared/CheckboxSettingSection";

export default function NetworkFamilyRegistration() {
  const [{ hasDiosync }] = useNetworkMetadata();
  const label = `Enable Family & Visitor Registration`;

  return (
    <CheckboxSettingSection
      setting="networkFamilyRegistration"
      label={label}
      disabled={hasDiosync}
    />
  );
}
